<a (click)="getRequestFile()" [style.display]="showFileLink ? 'block' : 'none'">
    <img  width = "25" height="20"  src="assets/Images/requestFile.png" >
</a>